module.exports = __webpack_public_path__ + "static/media/ProformaTotal.3dace9e4.png";